/**
 * @generated SignedSource<<b77a8ba8f5ddd9f4da4b92ed8f80c2cd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type InstantBuyStatus = "CLOSED" | "OPEN" | "PURCHASED" | "%future added value";
export type ProductTrackInstantBuysQuery$variables = {
  userId: string;
};
export type ProductTrackInstantBuysQuery$data = {
  readonly user: {
    readonly instantBuys: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly lineItems: ReadonlyArray<{
          readonly priceAmount: number;
          readonly productInstance: {
            readonly hubProduct: {
              readonly id: string;
              readonly product: {
                readonly id: string;
                readonly name: string;
              };
            };
          };
        }>;
        readonly purchasedAt: any | null | undefined;
        readonly status: InstantBuyStatus;
      }>;
    };
  } | null | undefined;
};
export type ProductTrackInstantBuysQuery = {
  response: ProductTrackInstantBuysQuery$data;
  variables: ProductTrackInstantBuysQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "userId"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "orderBy",
            "value": [
              {
                "field": "CREATED_AT",
                "ordering": "ASC"
              }
            ]
          },
          {
            "kind": "Literal",
            "name": "pagination",
            "value": {
              "page": 0,
              "pageSize": 1000000
            }
          }
        ],
        "concreteType": "InstantBuyPage",
        "kind": "LinkedField",
        "name": "instantBuys",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InstantBuy",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "purchasedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LineItem",
                "kind": "LinkedField",
                "name": "lineItems",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "priceAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductInstance",
                    "kind": "LinkedField",
                    "name": "productInstance",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HubProduct",
                        "kind": "LinkedField",
                        "name": "hubProduct",
                        "plural": false,
                        "selections": [
                          (v1/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "product",
                            "plural": false,
                            "selections": [
                              (v1/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "instantBuys(orderBy:[{\"field\":\"CREATED_AT\",\"ordering\":\"ASC\"}],pagination:{\"page\":0,\"pageSize\":1000000})"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductTrackInstantBuysQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ProductTrackInstantBuysQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "609bdb72c5b4870fc95564d517dd2235",
    "id": null,
    "metadata": {},
    "name": "ProductTrackInstantBuysQuery",
    "operationKind": "query",
    "text": "query ProductTrackInstantBuysQuery(\n  $userId: UUID!\n) {\n  user(id: $userId) {\n    instantBuys(pagination: {page: 0, pageSize: 1000000}, orderBy: [{field: CREATED_AT, ordering: ASC}]) {\n      nodes {\n        id\n        status\n        purchasedAt\n        lineItems {\n          priceAmount\n          productInstance {\n            hubProduct {\n              id\n              product {\n                id\n                name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5b947e48f1f889d1f703beff186a5b00";

export default node;
